import Amazon from './Systems/Amazon';
import Amplitude from './Systems/Amplitude';
import Google from './Systems/Google';
import Google4 from './Systems/Google4';

export enum SYSTEMS_NAMES {
    ga = 'ga',
    ga4 = 'ga4',
    amazon = 'amazon',
    amplitude = 'amplitude',
}

export const SYSTEMS = {
    ga: Google,
    ga4: Google4,
    amazon: Amazon,
    amplitude: Amplitude,
};

export enum ENV {
    develop = 'develop',
    stage = 'stage',
    preprod = 'preprod',
    prod = 'prod',
}

export const DEFAULT_EMPTY_URL_PARAMS = { data: 'empty_url_store' };

export const SYSTEMS_WITH_USER_PROPERTIES = [SYSTEMS_NAMES.amplitude];
